import { render, staticRenderFns } from "./segment-management.vue?vue&type=template&id=6f61c4d6&"
import script from "./segment-management.vue?vue&type=script&lang=js&"
export * from "./segment-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports